// extracted by mini-css-extract-plugin
export default {"component":"KeeperAttentionInfoBox-module__component-tT9y"};